import React from "react";
import {
  FaChalkboardTeacher,
  FaGraduationCap,
  FaUsers,
  FaLaptopCode,
  FaCheckCircle,
  FaArrowRight,
  FaBuilding,
  FaHospital,
  FaUniversity,
  FaIndustry,
  FaShoppingCart,
} from "react-icons/fa";
import Navbar from "./Navbar";

const services = [
  {
    icon: <FaChalkboardTeacher size={40} />,
    title: "Corporate IT Training",
    desc: "Customized technical training programs for employees to improve productivity and technical expertise.",
  },
  {
    icon: <FaGraduationCap size={40} />,
    title: "Campus Recruitment Training",
    desc: "Prepare final-year students with aptitude, coding, soft skills, and interview training.",
  },
  {
    icon: <FaLaptopCode size={40} />,
    title: "Dedicated Development Team",
    desc: "Hire skilled developers for your projects with flexible engagement models.",
  },
  {
    icon: <FaUsers size={40} />,
    title: "IT Consulting",
    desc: "Technology consulting, digital transformation, and software development guidance.",
  },
];

const industries = [
  {
    icon: <FaBuilding size={35} />,
    name: "Banking",
  },
  {
    icon: <FaHospital size={35} />,
    name: "Healthcare",
  },
  {
    icon: <FaUniversity size={35} />,
    name: "Education",
  },
  {
    icon: <FaIndustry size={35} />,
    name: "Manufacturing",
  },
  {
    icon: <FaShoppingCart size={35} />,
    name: "Retail",
  },
];

const stats = [
  {
    number: "500+",
    title: "Students Trained",
  },
  {
    number: "50+",
    title: "Corporate Batches",
  },
  {
    number: "25+",
    title: "Courses",
  },
  {
    number: "95%",
    title: "Placement Support",
  },
];

const Business = () => {
  return (
    <>
        <Navbar/>
        <section className="bg-gray-50">

      {/* Hero */}

      <div className="bg-primary text-white py-24">

        <div className="max-w-7xl mx-auto px-6 text-center">

          <h1 className="text-5xl font-bold">
            Empowering Businesses Through Technology
          </h1>

          <p className="text-xl mt-6 text-blue-100 max-w-3xl mx-auto">
            MSM Technologies partners with organizations to deliver
            corporate training, campus recruitment programs, and
            technology consulting services.
          </p>

          <div className="mt-10 flex flex-wrap justify-center gap-5">

            <button className="bg-white text-primary px-8 py-3 rounded-xl font-semibold hover:scale-105 transition">
              Request Proposal
            </button>

            <button className="border border-white px-8 py-3 rounded-xl hover:bg-white hover:text-primary transition">
              Talk to an Expert
            </button>

          </div>

        </div>

      </div>

      {/* Services */}

      <div className="max-w-7xl mx-auto py-20 px-6">

        <div className="text-center mb-14">

          <h2 className="text-4xl font-bold text-primary">
            Business Services
          </h2>

          <p className="text-gray-600 mt-3">
            Helping organizations build skilled technology teams.
          </p>

        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

          {services.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg p-8 hover:-translate-y-2 transition"
            >
              <div className="text-primary mb-5">
                {item.icon}
              </div>

              <h3 className="font-bold text-xl mb-3">
                {item.title}
              </h3>

              <p className="text-gray-600 leading-7">
                {item.desc}
              </p>

            </div>
          ))}

        </div>

      </div>

      {/* Why Choose Us */}

      <div className="bg-white py-20">

        <div className="max-w-7xl mx-auto px-6">

          <div className="grid lg:grid-cols-2 gap-16 items-center">

            <div>

              <h2 className="text-4xl font-bold text-primary mb-8">
                Why Partner With MSM Technologies?
              </h2>

              {[
                "Industry-certified trainers",
                "Customized corporate training",
                "Online & On-site sessions",
                "Hands-on practical learning",
                "Affordable pricing",
                "Post-training support",
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex items-center mb-5"
                >
                  <FaCheckCircle className="text-green-500 mr-4" />

                  <span className="text-lg text-gray-700">
                    {item}
                  </span>
                </div>
              ))}

            </div>

            <div className="bg-primary rounded-3xl text-white p-12">

              <h3 className="text-3xl font-bold mb-8">
                Our Process
              </h3>

              {[
                "Requirement Discussion",
                "Training Plan",
                "Training Delivery",
                "Assessment",
                "Certification & Support",
              ].map((step, index) => (
                <div
                  key={index}
                  className="flex items-center mb-5"
                >
                  <div className="w-10 h-10 rounded-full bg-white text-primary flex items-center justify-center font-bold mr-5">
                    {index + 1}
                  </div>

                  {step}
                </div>
              ))}

            </div>

          </div>

        </div>

      </div>

      {/* Industries */}

      <div className="py-20 bg-gray-100">

        <div className="max-w-7xl mx-auto px-6">

          <h2 className="text-center text-4xl font-bold text-primary mb-14">
            Industries We Serve
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">

            {industries.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md p-8 text-center hover:bg-primary hover:text-white transition"
              >
                <div className="flex justify-center mb-4">
                  {item.icon}
                </div>

                <h3 className="font-semibold">
                  {item.name}
                </h3>

              </div>
            ))}

          </div>

        </div>

      </div>

      {/* Statistics */}

      <div className="bg-white py-20">

        <div className="max-w-6xl mx-auto grid md:grid-cols-4 gap-8 px-6">

          {stats.map((item, index) => (
            <div
              key={index}
              className="text-center bg-gray-50 rounded-2xl shadow-md p-10"
            >
              <h2 className="text-5xl font-bold text-primary">
                {item.number}
              </h2>

              <p className="mt-4 text-gray-600">
                {item.title}
              </p>

            </div>
          ))}

        </div>

      </div>

      {/* CTA */}

      <div className="bg-primary text-white py-24">

        <div className="max-w-4xl mx-auto text-center px-6">

          <h2 className="text-5xl font-bold mb-6">
            Ready to Upskill Your Team?
          </h2>

          <p className="text-xl text-blue-100 mb-10">
            Let's build a customized learning program for your
            organization.
          </p>

          <button className="bg-white text-primary px-10 py-4 rounded-xl font-bold hover:scale-105 transition inline-flex items-center gap-3">
            Request a Proposal
            <FaArrowRight />
          </button>

        </div>

      </div>

    </section>
    </>
  );
};

export default Business;